if (!customElements.get('upsell-modal')) {
  customElements.define(
    'upsell-modal',
    class UpsellModal extends ModalDialog {
      constructor() {
        super();
        this.isInit = false;
        this.handleChangeBind = this.handleChange.bind(this);
        this.hideBind = this.hide.bind(this);
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        super.connectedCallback();
        this.initUpsell();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleChangeBind);

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      hide() {
        super.hide();
        this.removeUpsellScript();
      }

      show(opener) {
        super.show(opener);
        this.appendUpsellScript(this.buildItemArray());
      }

      initUpsell() {
        if (this.isInit) return;
        this.upsellVersion = this.dataset.upsellVersion;
        this.productFormId = this.dataset.productFormId;
        if (!this.dataset.upsellVersion || !this.dataset.productFormId) {
          console.error('UpsellModal: Missing required data attributes.');
          return; 
        }

        this.productForm = document.querySelector(`#${ this.productFormId }`);
        this.upsellInputs = [...this.querySelectorAll('[data-upsell-item]')];
        this.giftInputs = [...this.querySelectorAll('[data-upsell-gift-item]')];
        this.addEventListener('change', this.handleChangeBind);
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.hideBind);

        this.classList.add('upsell-modal--init');
        this.isInit = true;
      }

      handleChange(evt) {
        if (!this.hasAttribute('open')) return;
        this.appendUpsellScript(this.buildItemArray());
      }

      buildItemArray() {
        const upsellItems = this.upsellInputs.map(input => {
          return {
            id: input.value,
            quantity: 1,
            properties: {
              _upsell_version: this.upsellVersion,
              _upsell_item: true
            }
          };
        });
        const giftItems = this.giftInputs.map(input => {
          const item = {
            id: input.value,
            quantity: input.dataset.quantity || 1,
            properties: {
              _upsell_version: this.upsellVersion,
              _upsell_gift_item: true
            }
          };

          return item;
        });

        return [...upsellItems, ...giftItems];
      }

      appendUpsellScript(upsellItems) {
        this.removeUpsellScript();
        // Create a script tag to hold the upsell item array
        const upsellScript = document.createElement('script');
        upsellScript.type = 'text/javascript';
        upsellScript.setAttribute('data-upsell-items', '');
        upsellScript.innerHTML = JSON.stringify(upsellItems);
        this.productForm.appendChild(upsellScript);
      }

      removeUpsellScript() {
        const upsellScript = this.productForm.querySelector('[data-upsell-items]');
        if (upsellScript) {
          upsellScript.remove();
        }
      }
    }
  );
}
